export default __webpack_public_path__ + "static/documentary3-53b09f0f00fdb5e58092580168e7269c.jpg";